import { CommonModule } from '@angular/common';
// Services
import { ToastMessagesService } from 'NewAngular/features/components/toast-messages/toast-messages.service';
// Modules
import { IconModule } from '../../directives/icon/icon.module';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/features/components/toast-messages/toast-messages.service";
import * as i2 from "@angular/common";
import * as i3 from "../../directives/icon/icon.directive";
const _forTrack0 = ($index, $item) => $item.id;
function ToastMessagesComponent_ul_0_For_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 2);
    i0.ɵɵelement(1, "div", 3)(2, "div", 4);
    i0.ɵɵelementStart(3, "div", 5);
    i0.ɵɵlistener("click", function ToastMessagesComponent_ul_0_For_2_Template_div_click_3_listener() { const message_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.toastMessageService.removeMessage(message_r2.id)); });
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 6);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const message_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", message_r2.css);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", message_r2.innerHtml, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("name", "icon-close");
} }
function ToastMessagesComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 1);
    i0.ɵɵrepeaterCreate(1, ToastMessagesComponent_ul_0_For_2_Template, 6, 3, "li", 2, _forTrack0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.toastMessageService.messages);
} }
export class ToastMessagesComponent {
    constructor(toastMessageService) {
        this.toastMessageService = toastMessageService;
    }
}
ToastMessagesComponent.ɵfac = function ToastMessagesComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ToastMessagesComponent)(i0.ɵɵdirectiveInject(i1.ToastMessagesService)); };
ToastMessagesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ToastMessagesComponent, selectors: [["ycn-toast-messages"]], decls: 1, vars: 1, consts: [["class", "toast toast-bottom-left flex-column", "style", "position: fixed; z-index: 2000", 4, "ngIf"], [1, "toast", "toast-bottom-left", "flex-column", 2, "position", "fixed", "z-index", "2000"], [1, "ml-auto", "mr-auto", "toast", "toast-context", "width-240", 3, "ngClass"], [1, "toast-text", "width-full", 3, "innerHTML"], [1, "divider-vertical", "ml-10"], ["data-test-id", "toast-close", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["role", "img", "ycnIcon", "", 1, "icon-close", 3, "name"]], template: function ToastMessagesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ToastMessagesComponent_ul_0_Template, 3, 0, "ul", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.toastMessageService.messages.length > 0);
    } }, dependencies: [CommonModule, i2.NgClass, i2.NgIf, IconModule, i3.IconDirective], encapsulation: 2 });
